import { useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import VerificationCodeForm from './VerificationCodeForm';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import LogoComponent from '../logo/LogoComponent';
import StyledBox from './styled/SignUp/StyledBox';
import RegistrationForm from './RegistrationForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { Typography } from '../new/Typography';

const SignUp = () => {
   const location = useLocation();
   
  const isVerificationRequested = useSelector(
    (state: RootState) => state.user.verificationRequested,
  );

  const fromSignIn = location.state?.fromSignIn
  
  const isSendingVerificationCode = useSelector(
    (state: RootState) => state.user.isSendingVerificationCode,
  );

  const isFromInvToken = useSelector(
    (state: RootState) => state.user.isFromInvToken,
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (isFromInvToken) {
      navigate('/auth/sign-in', {
        state: {
          hasInvUserSuccessfullyCreated: true,
        },
      });
    }
  }, [isFromInvToken]);

  if (isSendingVerificationCode) {
    return (
      <div
        style={{
          backgroundColor: '#0000005e',
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '1.25rem',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress sx={{ color: '#FFF' }} size={50} />
        <Typography sx={{ marginTop: '0.9375rem', fontSize: '1.25rem', color: '#FFF' }}>
          Generating code... Please wait!
        </Typography>
      </div>
    );
  }

  return (
    <StyledBox>
      <Typography variant='h5' sx={{ fontSize: '1.875rem', mt: 4 }}>
        {isVerificationRequested || fromSignIn ? 'Verify Your Email' : 'Create Your Account'}
      </Typography>
      {!isVerificationRequested && !fromSignIn? (
        <RegistrationForm />
      ) : (
        <VerificationCodeForm origin={fromSignIn ? 'signin' : 'signup'} />
      )}
    </StyledBox>
  );
};
export default SignUp;
